"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_ORDERS = 'LOAD_ORDERS';
exports.LOAD_ORDER = 'LOAD_ORDER';
exports.CREATE_ORDER = 'CREATE_ORDER';
exports.UPDATE_ORDER = 'UPDATE_ORDER';
exports.SUBMIT_ORDER = 'SUBMIT_ORDER';
exports.LOAD_QUOTES = 'LOAD_QUOTES';
exports.LOAD_QUOTE = 'LOAD_QUOTE';
exports.CREATE_QUOTE = 'CREATE_QUOTE';
exports.UPDATE_QUOTE = 'UPDATE_QUOTE';
exports.SUBMIT_QUOTE = 'SUBMIT_QUOTE';
exports.LOAD_QUOTEREQUESTS = 'LOAD_QUOTEREQUESTS';
exports.LOAD_QUOTEREQUEST = 'LOAD_QUOTEREQUEST';
exports.CREATE_QUOTEREQUEST = 'CREATE_QUOTEREQUEST';
exports.UPDATE_QUOTEREQUEST = 'UPDATE_QUOTEREQUEST';
exports.SUBMIT_QUOTEREQUEST = 'SUBMIT_QUOTEREQUEST';
exports.LOAD_CARTS = 'LOAD_CARTS';
exports.LOAD_CART = 'LOAD_CART';
exports.CREATE_CART = 'CREATE_CART';
exports.UPDATE_CART = 'UPDATE_CART';
exports.INACTIVATE_CART = 'INACTIVATE_CART';
exports.LOAD_DELIVERIES = 'LOAD_DELIVERIES';
exports.LOAD_DELIVERY = 'LOAD_DELIVERY';
exports.CREATE_DELIVERY = 'CREATE_DELIVERY';
exports.UPDATE_DELIVERY = 'UPDATE_DELIVERY';
exports.LOAD_DELIVERY_OPTIONS = 'LOAD_DELIVERY_OPTIONS';
exports.LOAD_DELIVERY_OPTION = 'LOAD_DELIVERY_OPTION';
exports.CREATE_DELIVERY_OPTION = 'CREATE_DELIVERY_OPTION';
exports.UPDATE_DELIVERY_OPTION = 'UPDATE_DELIVERY_OPTION';
exports.ADD_DELIVERY_OPTION_PERMISSION = 'ADD_DELIVERY_OPTION_PERMISSION';
exports.SET_DELIVERY_OPTION_ACCESSIBILITY = 'SET_DELIVERY_OPTION_ACCESSIBILITY';
exports.LOAD_PUBLIC_DELIVERYOPTIONS = 'LOAD_PUBLIC_DELIVERYOPTIONS';
exports.LOAD_PUBLIC_DELIVERYOPTION = 'LOAD_PUBLIC_DELIVERYOPTION';
exports.LOAD_PRODUCTSTOCKS = 'LOAD_PRODUCTSTOCKS';
exports.LOAD_PRODUCTSTOCK = 'LOAD_PRODUCTSTOCK';
exports.CREATE_PRODUCTSTOCK = 'CREATE_PRODUCTSTOCK';
exports.UPDATE_PRODUCTSTOCK = 'UPDATE_PRODUCTSTOCK';
exports.ADD_PRODUCTSTOCK_PERMISSION = 'ADD_PRODUCTSTOCK_PERMISSION';
exports.SET_PRODUCTSTOCK_ACCESSIBILITY = 'SET_PRODUCTSTOCK_ACCESSIBILITY';
exports.LOAD_PUBLIC_PRODUCTSTOCKS = 'LOAD_PUBLIC_PRODUCTSTOCKS';
exports.LOAD_PUBLIC_PRODUCTSTOCK = 'LOAD_PUBLIC_PRODUCTSTOCK';
exports.LOAD_PAYMENT_OPTIONS = 'LOAD_PAYMENT_OPTIONS';
exports.LOAD_PAYMENT_OPTION = 'LOAD_PAYMENT_OPTION';
exports.CREATE_PAYMENT_OPTION = 'CREATE_PAYMENT_OPTION';
exports.UPDATE_PAYMENT_OPTION = 'UPDATE_PAYMENT_OPTION';
exports.ADD_PAYMENT_OPTION_PERMISSION = 'ADD_PAYMENT_OPTION_PERMISSION';
exports.SET_PAYMENT_OPTION_ACCESSIBILITY = 'SET_PAYMENT_OPTION_ACCESSIBILITY';
exports.LOAD_PUBLIC_PAYMENTOPTIONS = 'LOAD_PUBLIC_PAYMENTOPTIONS';
exports.LOAD_PUBLIC_PAYMENTOPTION = 'LOAD_PUBLIC_PAYMENTOPTION';
exports.LOAD_PAYMENTS = 'LOAD_PAYMENTS';
exports.LOAD_PAYMENT = 'LOAD_PAYMENT';
exports.CREATE_PAYMENT = 'CREATE_PAYMENT';
exports.UPDATE_PAYMENT = 'UPDATE_PAYMENT';
exports.LOAD_CUSTOMERS = 'LOAD_CUSTOMERS';
exports.LOAD_CUSTOMER = 'LOAD_CUSTOMER';
exports.CREATE_CUSTOMER = 'CREATE_CUSTOMER';
exports.UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
exports.LOAD_PRICELISTS = 'LOAD_PRICELISTS';
exports.LOAD_PRICELIST = 'LOAD_PRICELIST';
exports.CREATE_PRICELIST = 'CREATE_PRICELIST';
exports.UPDATE_PRICELIST = 'UPDATE_PRICELIST';
exports.ADD_PRICELIST_PERMISSION = 'ADD_PRICELIST_PERMISSION';
exports.REMOVE_PRICELIST_PERMISSION = 'REMOVE_PRICELIST_PERMISSION';
exports.SET_PRICELIST_ACCESSIBILITY = 'SET_PRICELIST_ACCESSIBILITY';
exports.SET_PRICELIST_ORGANIZATION = 'SET_PRICELIST_ORGANIZATION';
exports.ADD_PRICELIST_RELATION = 'ADD_PRICELIST_RELATION';
exports.REMOVE_PRICELIST_RELATION = 'REMOVE_PRICELIST_RELATION';
exports.LOAD_PUBLIC_PRICELISTS = 'LOAD_PUBLIC_PRICELISTS';
exports.LOAD_PUBLIC_PRICELIST = 'LOAD_PUBLIC_PRICELIST';
exports.LOAD_DISCOUNTS = 'LOAD_DISCOUNTS';
exports.LOAD_DISCOUNT = 'LOAD_DISCOUNT';
exports.CREATE_DISCOUNT = 'CREATE_DISCOUNT';
exports.UPDATE_DISCOUNT = 'UPDATE_DISCOUNT';
exports.ADD_DISCOUNT_PERMISSION = 'ADD_DISCOUNT_PERMISSION';
exports.REMOVE_DISCOUNT_PERMISSION = 'REMOVE_DISCOUNT_PERMISSION';
exports.SET_DISCOUNT_ACCESSIBILITY = 'SET_DISCOUNT_ACCESSIBILITY';
exports.SET_DISCOUNT_ORGANIZATION = 'SET_DISCOUNT_ORGANIZATION';
exports.ADD_DISCOUNT_RELATION = 'ADD_DISCOUNT_RELATION';
exports.REMOVE_DISCOUNT_RELATION = 'REMOVE_DISCOUNT_RELATION';
exports.LOAD_PUBLIC_DISCOUNTS = 'LOAD_PUBLIC_DISCOUNTS';
exports.LOAD_PUBLIC_DISCOUNT = 'LOAD_PUBLIC_DISCOUNT';
exports.LOAD_LOGISTICSOPTIONS = 'LOAD_LOGISTICSOPTIONS';
exports.LOAD_LOGISTICSOPTION = 'LOAD_LOGISTICSOPTION';
exports.CREATE_LOGISTICSOPTION = 'CREATE_LOGISTICSOPTION';
exports.UPDATE_LOGISTICSOPTION = 'UPDATE_LOGISTICSOPTION';
exports.ADD_LOGISTICSOPTION_PERMISSION = 'ADD_LOGISTICSOPTION_PERMISSION';
exports.SET_LOGISTICSOPTION_ACCESSIBILITY = 'SET_LOGISTICSOPTION_ACCESSIBILITY';